import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Grid, TableHead, TableRow, TableBody, Box } from "@mui/material";
import { Button, Dialog } from "@totalsoft/rocket-ui";
import ScoringDimensionPeriodItemComponent from "./ScoringDimensionPeriodItemComponent";
import { DenseHeaderCell, MinWidthTable } from "components/common/TableStyles";

const ScoringDimensionPeriodListComponent = ({
  showModal,
  periods,
  dimensions,
  onCloseLocalDimensionListModal,
  onPeriodDimensionChange,
  onAddNewPeriodDimension
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={showModal}
      aria-labelledby="periodDimensions-dialog-title"
      maxWidth="md"
      title={t("Scoring.ScoringIndicator.Dimensions.Title")}
      actions={
        <Box display="flex" gap={1} mb={1} mx={1}>
          <Button color="primary" variant="contained" onClick={onAddNewPeriodDimension} sx={{ marginTop: "1.5rem" }}>
            {t("Add")}
          </Button>
          <Button
            onClick={onCloseLocalDimensionListModal}
            color="primary"
            variant="outlined"
            sx={{ marginLeft: ".25rem", marginTop: "1.5rem" }}
          >
            {t("Close")}
          </Button>
        </Box>
      }
      content={
        periods && (
          <Grid container>
            <Grid item xs={12} sm={12} md={12} pb="5" sx={{ overflowX: "auto" }}>
              <MinWidthTable>
                <TableHead>
                  <TableRow>
                    <DenseHeaderCell sx={{ width: "10%" }}>
                      {t("Scoring.ScoringIndicator.Dimensions.Selected")}
                    </DenseHeaderCell>
                    <DenseHeaderCell>{t("Scoring.ScoringIndicator.Dimensions.Year")}</DenseHeaderCell>
                    <DenseHeaderCell>{t("Scoring.ScoringIndicator.Dimensions.Month")}</DenseHeaderCell>
                    <DenseHeaderCell>{t("Scoring.ScoringIndicator.Dimensions.Indicator")}</DenseHeaderCell>
                    <DenseHeaderCell>{t("Scoring.ScoringIndicator.Dimensions.Period")}</DenseHeaderCell>
                    <DenseHeaderCell>{t("Scoring.ScoringIndicator.Dimensions.Source")}</DenseHeaderCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {periods &&
                    periods.map(({ document, validationInfo }, idx) => {
                      return (
                        <ScoringDimensionPeriodItemComponent
                          disabled={document.isReadOnly}
                          key={document.documentScoringFinancialIndicatorPeriodDimensionId}
                          document={document}
                          validationInfo={validationInfo}
                          onPeriodDimensionChange={onPeriodDimensionChange(idx)}
                          dimensions={dimensions}
                        />
                      );
                    })}
                </TableBody>
              </MinWidthTable>
            </Grid>
          </Grid>
        )
      }
    />
  );
};

ScoringDimensionPeriodListComponent.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onCloseLocalDimensionListModal: PropTypes.func.isRequired,
  dimensions: PropTypes.array,
  periods: PropTypes.array.isRequired,
  onAddNewPeriodDimension: PropTypes.func.isRequired,
  onPeriodDimensionChange: PropTypes.func.isRequired
};

export default ScoringDimensionPeriodListComponent;
